import { Button } from 'components/shard'
import React from 'react'
import styled from 'styled-components'

const ImageViewer = ({ isOpen, onClose, imgSrc }) => {
  return (
    <>
      {isOpen && (
        <StyledImageViewer>
          <img src={imgSrc} alt={imgSrc} />
          <div className="button_wrapper">
            <Button primary onClick={onClose}>
              閉じる
            </Button>
          </div>
        </StyledImageViewer>
      )}
    </>
  )
}

const StyledImageViewer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: #444;
  z-index: 100;
  padding: 20px;
  box-sizing: border-box;
  overflow-y: scroll;

  > img {
    width: 100%;
  }

  > .button_wrapper {
    margin: 20px 0;
    text-align: center;
  }
`

export default ImageViewer
